module.exports = __webpack_public_path__ + "static/mail-662887fd7667812cae45cfa3e0ec6ca8.png";